import React, {useEffect, useState} from 'react';

import styled from "styled-components";
import useStore from "../Store";
const MainDiv=styled.div`
    width: 100%;
    height: ${(props)=>props.height};    
    text-align: left;
`
const MenuItem=styled.div`
    display: inline-flex;
    padding:5px;
    margin-left: 20px;    
    width: 150px;
    cursor: pointer;
    background: #435367;
    justify-content: center;

    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-size: 100%;
    text-align: center;
    color: #19C6F4;
           
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    transition: all 0.3s ease;
    
    &:hover{
        transform: scale(1.15);
        background-color: #19C6F4;
        box-shadow: 0 5px 5px 5px rgba(25, 198, 244, 25.6);
        color: white;
    }
`
const SelectedMenuItem=styled(MenuItem)`
    background-color: #19C6F4;
    color: white;    
    box-shadow: 5px 5px 5px 0px rgba(25, 198, 244, 25.6);
`
const SubPagesMenu = ({selectedPage, selectedSubPage, setSelectedSubPage}) => {
    const Pages=useStore((state)=>state.PagesData)
    const Language=useStore((state)=>state.Language);
    const Languages=useStore((state)=>state.Languages);
    const [height, setHeight]=useState("30px")
    function setSubPage(event){
        if(Pages[selectedPage].Subpages[event.currentTarget.getAttribute("data-index")].Rights.read)
            setSelectedSubPage(event.currentTarget.id)
        else alert("You don't have a permission")
    }
    useEffect(() => {
        if(Pages[selectedPage].Subpages.length===0) {
            setSelectedSubPage(selectedPage)
            setHeight("0px");
        } else setHeight("30px")
    }, [selectedPage]);
    // console.log(Pages)
    return (
        <MainDiv height={height}>
            {
                Pages[selectedPage].Subpages.length>0&&Pages[selectedPage].Subpages.map((element, index)=>{
                    if(element.en===selectedSubPage)
                        return (
                            <SelectedMenuItem
                                onClick={setSubPage}
                                id={element.en}
                                data-index={index}
                                key={element.en}
                            >
                                {element[Languages[Language]]}
                            </SelectedMenuItem>
                        )
                    return (
                        <MenuItem
                            onClick={setSubPage}
                            id={element.en}
                            key={element.en}
                            data-index={index}
                        >
                            {element[Languages[Language]]}
                        </MenuItem>
                    )
                })
            }
        </MainDiv>
    );
};

export default SubPagesMenu;